module.exports = __webpack_public_path__ + "img/overview-shape.9fd446f3.png";